module.exports = __webpack_public_path__ + "static/media/bg_11.png";


//////////////////
// WEBPACK FOOTER
// ./src/img/bg_11.png
// module id = 56
// module chunks = 0